import React from "react";
import { useLang } from "../i18n";
import { ArrowRight, ArrowDown } from "lucide-react";

export default function Hero() {
  const { t } = useLang();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] overflow-hidden flex items-center pt-28 pb-16"
      style={{ backgroundColor: "#0A1F1B" }}
    >
      {/* Logo watermark — real GT Strategy logo, faded large */}
      <div className="absolute inset-0 flex items-center justify-end pr-0 lg:pr-4 pointer-events-none select-none">
        <img
          src="/brand/logo-gt-slogan.svg"
          alt=""
          className="h-[110%] max-h-none w-auto opacity-[0.045] mix-blend-screen"
          style={{ filter: "brightness(2)" }}
        />
      </div>

      {/* Vignette */}
      <div className="absolute inset-0 bg-gradient-to-r from-gt-bg via-gt-bg/85 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-gt-bg/60" />
      <div className="gt-grain absolute inset-0" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16">
          {/* Left: headline */}
          <div className="lg:col-span-8 gt-reveal">
            <div className="section-eyebrow mb-10">
              <span className="gt-eyebrow">{t.hero.eyebrow}</span>
            </div>
            <h1
              className="gt-display text-gt-cream text-[3rem] sm:text-[4.5rem] md:text-[6rem] lg:text-[7.5rem]"
              data-testid="hero-title"
            >
              <span className="block">{t.hero.title_a}</span>
              <span className="block">{t.hero.title_b}</span>
              <span className="block gt-display-light text-gt-cream/55 mt-2">{t.hero.title_c}</span>
            </h1>
            <p className="mt-10 text-base md:text-xl text-gt-ink/80 max-w-2xl leading-relaxed font-body">
              {t.hero.subtitle}
            </p>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="group inline-flex items-center justify-between gap-4 px-7 py-4 text-xs btn-cream min-w-[260px]"
              >
                {t.hero.cta_primary}
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="group inline-flex items-center justify-between gap-4 px-7 py-4 text-xs btn-outline-cream min-w-[260px]"
              >
                {t.hero.cta_secondary}
                <ArrowDown size={16} className="group-hover:translate-y-1 transition-transform" />
              </a>
            </div>

            {/* Trust strip */}
            <div className="mt-16 flex flex-wrap gap-x-10 gap-y-4 items-center text-[0.7rem] uppercase tracking-[0.22em] text-gt-mute">
              <span>{t.hero.meta_a}</span>
              <span className="text-gt-cream/30">·</span>
              <span>{t.hero.meta_b}</span>
              <span className="text-gt-cream/30">·</span>
              <span>{t.hero.meta_c}</span>
            </div>
          </div>
        </div>
      </div>

      {/* scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-gt-mute">
        <div className="w-px h-10 bg-gradient-to-b from-transparent to-gt-cream/50" />
        <span className="text-[0.6rem] uppercase tracking-[0.3em]">scroll</span>
      </div>
    </section>
  );
}
